import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { TransactionQueryClient } from "../../parentApi";

const client = new TransactionQueryClient(app_uri, axiosClient());

export default client;
